export default function getBlogLink(slug) {
  return `/blog/${slug}`;
}
